/* @ngInject */
function WorkflowFiltersController ($scope, $translate, $location, $timeout, SegmentService, BriefingService, UserService, BoardsService) {
  const workflowFilters = {
    isArchived: false,
    showOcculted: false
  }
  const assigneesMultiselectPagination = {
    top: 8,
    skip: 0
  }
  const usedFormsPagination = {
    top: 8,
    skip: 0
  }
  const authorsMultiselectPagination = {
    top: 8,
    skip: 0
  }
  const api = {
    _onChangeFilters,
    _onHeightsChange,
    _setDefaultViewMode,
    _adaptFiltersToCalendarView,
    _handleGetUsersForFilters,
    _handleGetFormsForFilter,
    _initializeFiltersOptions,
    _setUrl,
    _addFiltersInitialValues,
    _initializeFilters,
    _loadAdmsAndDesigners,
    _loadAuthors,
    _handleAPIResponseUsersFilter,
    _handleAPIResponseFormsFilter,
    _standardizeUrl,
    _loadUsedForms
  }
  this.getApi = () => api

  $scope.filtersDataLoaded = false
  $scope.filtersConfig = [
    {
      id: 'creationDateFilter',
      fieldType: 'daterange',
      label: $translate.instant('creationDate'),
      start: null,
      end: null,
      onChange: (event) => {
        const start = event?.detail?.start
        const end = event?.detail?.end
        workflowFilters.creationDateStart = start
        workflowFilters.creationDateEnd = end

        if (start && end) {
          SegmentService.track('workflow-tasks-filter', {
            view_type: $scope.viewMode,
            board_id: $scope.boardId,
            task_data_create_start: start,
            task_data_create_end: end
          })
        }

        api._onChangeFilters(workflowFilters, true)
      }
    },
    {
      id: 'deliveryDateFilter',
      fieldType: 'daterange',
      icon: 'calendar',
      label: $translate.instant('deliveryDate'),
      start: null,
      end: null,
      onChange: (event) => {
        const start = event?.detail?.start
        const end = event?.detail?.end
        workflowFilters.deliveryDateStart = start
        workflowFilters.deliveryDateEnd = end

        if (start && end) {
          SegmentService.track('workflow-tasks-filter', {
            view_type: $scope.viewMode,
            board_id: $scope.boardId,
            task_date_finish_start: start,
            task_date_finish_end: end
          })
        }

        api._onChangeFilters(workflowFilters, true)
      }
    },
    {
      id: 'typeFilter',
      fieldType: 'multiselect',
      optionType: 'text',
      icon: 'file-text',
      label: $translate.instant('type'),
      hasMoreOptions: false,
      value: [],
      options: [],
      onChange: (event) => {
        const selectedTypes = event?.detail?.map((type) => type.value)
        workflowFilters.taskTypes = selectedTypes

        if (selectedTypes.length) {
          SegmentService.track('workflow-tasks-filter', {
            view_type: $scope.viewMode,
            board_id: $scope.boardId,
            task_type: selectedTypes
          })
        }

        api._onChangeFilters(workflowFilters, true)
      }
    },
    {
      id: 'statusFilter',
      fieldType: 'multiselect',
      optionType: 'text',
      icon: 'tag',
      label: $translate.instant('status'),
      hasMoreOptions: false,
      value: [],
      options: [],
      onChange: (event) => {
        const selectedStatus = event?.detail?.map((status) => status.value)
        workflowFilters.taskStatus = selectedStatus

        if (selectedStatus.length) {
          SegmentService.track('workflow-tasks-filter', {
            view_type: $scope.viewMode,
            board_id: $scope.boardId,
            task_status: selectedStatus
          })
        }

        api._onChangeFilters(workflowFilters, true)
      }
    },
    {
      id: 'assigneesFilter',
      fieldType: 'multiselect',
      optionType: 'user',
      icon: 'users',
      label: $translate.instant('workflow.assignee'),
      hasMoreOptions: true,
      value: [],
      options: [],
      searchText: null,
      onSearch: (event, filter) => {
        const resetPagination = true
        filter.searchText = event.detail.search

        api._loadAdmsAndDesigners(filter.searchText, resetPagination)
          .then((response) => api._handleAPIResponseUsersFilter(response, filter, event))
      },
      getMoreOptions: (event, filter) => {
        api._loadAdmsAndDesigners(filter.searchText)
          .then((response) => api._handleAPIResponseUsersFilter(response, filter, event))
      },
      onChange: (event) => {
        const selectedAssignees = event?.detail?.map((assignee) => assignee.value)
        workflowFilters.assignees = selectedAssignees

        if (selectedAssignees.length) {
          SegmentService.track('workflow-tasks-filter', {
            view_type: $scope.viewMode,
            board_id: $scope.boardId,
            task_accontable_users: selectedAssignees
          })
        }

        api._onChangeFilters(workflowFilters, true)
      }
    },
    {
      id: 'authorsFilter',
      fieldType: 'multiselect',
      optionType: 'user',
      icon: 'user',
      label: $translate.instant('workflow.requester'),
      hasMoreOptions: true,
      value: [],
      options: [],
      searchText: null,
      onSearch: (event, filter) => {
        const resetPagination = true
        filter.searchText = event.detail.search

        api._loadAuthors(filter.searchText, resetPagination)
          .then((response) => api._handleAPIResponseUsersFilter(response, filter, event))
      },
      getMoreOptions: (event, filter) => {
        api._loadAuthors(filter.searchText)
          .then((response) => api._handleAPIResponseUsersFilter(response, filter, event))
      },
      onChange: (event) => {
        const selectedRequesters = event?.detail?.map((requester) => requester.value)
        workflowFilters.authors = selectedRequesters

        if (selectedRequesters.length) {
          SegmentService.track('workflow-tasks-filter', {
            view_type: $scope.viewMode,
            board_id: $scope.boardId,
            task_request_user: selectedRequesters
          })
        }

        api._onChangeFilters(workflowFilters, true)
      }
    },
    {
      id: 'priorityFilter',
      fieldType: 'multiselect',
      optionType: 'text',
      icon: 'chevron-double-up',
      label: $translate.instant('priorityFilter'),
      hasMoreOptions: false,
      value: [],
      options: [],
      onChange: (event) => {
        const priorities = event?.detail?.map((priority) => priority.value)
        workflowFilters.priorities = priorities

        if (priorities.length) {
          SegmentService.track('workflow-tasks-filter', {
            view_type: $scope.viewMode,
            board_id: $scope.boardId,
            task_priority: priorities
          })
        }

        api._onChangeFilters(workflowFilters, true)
      }
    },
    {
      id: 'formsFilter',
      fieldType: 'multiselect',
      optionType: 'text',
      icon: 'file-text',
      label: $translate.instant('workflow.briefings'),
      hasMoreOptions: true,
      value: [],
      options: [],
      searchText: null,
      onSearch: (event, filter) => {
        const resetPagination = true
        filter.searchText = event.detail.search

        api._loadUsedForms(filter.searchText, resetPagination)
          .then((response) => api._handleAPIResponseFormsFilter(response, filter, event))
      },
      getMoreOptions: (event, filter) => {
        api._loadUsedForms(filter.searchText)
          .then((response) => api._handleAPIResponseFormsFilter(response, filter, event))
      },
      onChange: (event) => {
        const selectedForms = event?.detail?.map((form) => form.value)
        const selectedFormsLabel = event?.detail?.map((form) => form.label)
        workflowFilters.form = selectedForms

        if (selectedForms.length) {
          SegmentService.track('workflow-tasks-filter', {
            view_type: $scope.viewMode,
            board_id: $scope.boardId,
            task_form: selectedFormsLabel
          })
        }

        api._onChangeFilters(workflowFilters, true)
      }
    },
    {
      id: 'archivedFilter',
      fieldType: 'select',
      icon: 'eye',
      clearable: false,
      label: $translate.instant('archivedPlural'),
      value: {},
      options: [],
      onChange: (event) => {
        const archived = event?.detail?.value

        if (archived === undefined) {
          delete workflowFilters.isArchived
        } else {
          workflowFilters.isArchived = archived
        }

        SegmentService.track('workflow-tasks-filter', {
          view_type: $scope.viewMode,
          board_id: $scope.boardId,
          task_arquived: archived
        })

        api._onChangeFilters(workflowFilters, true)
      }
    }
  ]

  activate()

  function activate () {
    const url = $location.search()

    api._standardizeUrl(url)
    api._setDefaultViewMode()
    api._adaptFiltersToCalendarView()
    api._addFiltersInitialValues(url)
    api._setUrl($scope.boardId, workflowFilters)
    api._onChangeFilters(workflowFilters, false)
    api._initializeFilters()
  }

  function _standardizeUrl (url) {
    if (typeof url.isArchived === 'boolean') {
      return
    }

    if (url.isArchived === 'false') {
      url.isArchived = false
      return
    }

    if (url.isArchived === 'true') {
      url.isArchived = true
    }
  }

  function _initializeFilters () {
    const dataPromises = [
      api._loadAdmsAndDesigners(),
      api._loadAuthors(),
      api._loadUsedForms()
    ]

    Promise.all(dataPromises)
      .then(([adminsAndDesigners, tasksRequesters, usedForms]) => {
        api._handleGetUsersForFilters(adminsAndDesigners, 'assigneesFilter')
        api._handleGetUsersForFilters(tasksRequesters, 'authorsFilter')
        api._handleGetFormsForFilter(usedForms)

        api._initializeFiltersOptions()
      })
      .finally(() => {
        $scope.filtersDataLoaded = true
      })
  }

  function _handleAPIResponseFormsFilter (response, filter, filterEvent) {
    const rows = response.rows
    const totalRows = response.count

    const options = rows.map(form => {
      return {
        value: form.id,
        label: form.name
      }
    })

    filterEvent.target.options = options
    filter.hasMoreOptions = totalRows > filterEvent.target.allOptions.length
  }

  function _handleAPIResponseUsersFilter (response, filter, filterEvent) {
    const rows = response.rows
    const totalRows = response.count

    const optionsLength = filterEvent?.target?.allOptions?.length || 0

    const newOptions = rows.map(user => {
      const username = user.user_has_companies?.[0]?.name || user.name

      return {
        value: user.id,
        label: username,
        avatar: user.user_has_companies?.[0]?.profileImageId ? UserService.getUserProfileImage(user.id) : null
      }
    })
    filterEvent.target.options = newOptions
    filter.hasMoreOptions = totalRows > optionsLength
  }

  function _loadAdmsAndDesigners (search, resetPagination = false) {
    if (resetPagination) {
      assigneesMultiselectPagination.skip = 0
    }

    const options = {
      search,
      top: assigneesMultiselectPagination.top,
      skip: assigneesMultiselectPagination.skip
    }
    assigneesMultiselectPagination.skip += assigneesMultiselectPagination.top

    return UserService.getAdministratorsAndDesigners(options)
  }

  function _loadUsedForms (search, resetPagination = false) {
    if (resetPagination) {
      usedFormsPagination.skip = 0
    }

    const options = {
      search,
      top: usedFormsPagination.top,
      skip: usedFormsPagination.skip
    }
    usedFormsPagination.skip += usedFormsPagination.top

    return BriefingService.getUsedBriefingsByBoard($scope.boardId, options)
  }

  function _loadAuthors (search, resetPagination) {
    if (resetPagination) {
      authorsMultiselectPagination.skip = 0
    }

    const options = {
      search,
      top: authorsMultiselectPagination.top,
      skip: authorsMultiselectPagination.skip
    }
    authorsMultiselectPagination.skip += authorsMultiselectPagination.top

    return BoardsService.getTasksRequesters($scope.boardId, options)
  }

  function _onChangeFilters (workflowFilters, refreshTasks = true) {
    workflowFilters.showOcculted = $location.search().term ? null : false

    api._setUrl($scope.boardId, workflowFilters)
    api._onHeightsChange(0)

    $scope.$emit('workflow-filters-changed', {
      refreshTasks,
      newFiltersValue: workflowFilters
    })
  }

  function _onHeightsChange (timeoutMs = 200) {
    $scope.$emit('workflow-filters-adjust-heights', { timeoutMs })
  }

  function _setDefaultViewMode () {
    if ($scope.viewMode) {
      return
    }

    $scope.viewMode = 'kanban'
  }

  function _adaptFiltersToCalendarView () {
    if ($scope.viewMode !== 'calendar') {
      return
    }

    const deliveryDateFilterIndex = $scope.filtersConfig.findIndex(filter => filter.id === 'deliveryDateFilter')
    $scope.filtersConfig.splice(deliveryDateFilterIndex, 1)
  }

  function _handleGetUsersForFilters (response, filterName) {
    const rows = response.rows
    const totalRows = response.count

    if (!Array.isArray(rows)) {
      console.warn('Response must be an array')
      return
    }

    const filter = $scope.filtersConfig.find(filter => filter.id === filterName)

    if (!filter) {
      return
    }

    const mappedUsers = rows.map(user => {
      const username = user.user_has_companies?.[0]?.name || user.name

      return {
        value: user.id,
        label: username,
        avatar: user.user_has_companies?.[0]?.profileImageId ? UserService.getUserProfileImage(user.id) : null
      }
    })
    filter.options.push(...mappedUsers)
    filter.hasMoreOptions = totalRows > filter.options.length
  }

  function _handleGetFormsForFilter (response) {
    const rows = response.rows
    const totalRows = response.count

    if (!Array.isArray(rows)) {
      console.warn('Response must be an array')
      return
    }

    const formsFilterId = 'formsFilter'
    const filter = $scope.filtersConfig.find(filter => filter.id === formsFilterId)

    if (!filter) {
      return
    }

    const mappedOptions = rows.map(form => {
      return {
        value: form.id,
        label: form.name
      }
    })

    filter.options.push(...mappedOptions)
    filter.hasMoreOptions = totalRows > filter.options.length
  }

  function _initializeFiltersOptions () {
    let hasInitialValue = false

    const typeFilterOptions = [
      {
        label: $translate.instant('requests'),
        value: 'REQUEST'
      },
      {
        label: $translate.instant('tasks'),
        value: 'TASK'
      }
    ]
    const statusFilterOptions = [
      {
        label: $translate.instant('inboxStatus'),
        value: 'INBOX'
      },
      {
        label: $translate.instant('inProgress'),
        value: 'PROGRESS'
      },
      {
        label: $translate.instant('underReview'),
        value: 'REVIEW'
      },
      {
        label: $translate.instant('waitingAdjusts'),
        value: 'WAITING_ADM_ADJUST'
      },
      {
        label: $translate.instant('done'),
        value: 'DONE'
      }
    ]
    const prioritiesFilterOptions = [
      {
        label: $translate.instant('LOW'),
        value: 'LOW'
      },
      {
        label: $translate.instant('MEDIUM'),
        value: 'MEDIUM'
      },
      {
        label: $translate.instant('HIGH'),
        value: 'HIGH'
      },
      {
        label: $translate.instant('URGENT'),
        value: 'URGENT'
      }
    ]
    const archivedFilterOptions = [
      {
        label: $translate.instant('yes'),
        value: true
      },
      {
        label: $translate.instant('no'),
        value: false
      }
    ]

    $scope.filtersConfig.forEach((filter) => {
      switch (filter.id) {
        case 'creationDateFilter':
          if (workflowFilters.creationDateStart && workflowFilters.creationDateEnd) {
            filter.start = workflowFilters.creationDateStart
            filter.end = workflowFilters.creationDateEnd
          }

          break
        case 'deliveryDateFilter':
          if (workflowFilters.deliveryDateStart && workflowFilters.deliveryDateEnd) {
            filter.start = workflowFilters.deliveryDateStart
            filter.end = workflowFilters.deliveryDateEnd
          }

          break
        case 'typeFilter':
          filter.options = typeFilterOptions

          if (workflowFilters.taskTypes) {
            filter.value = typeFilterOptions.filter(opt => workflowFilters.taskTypes.includes(opt.value))
          }
          break
        case 'statusFilter':
          filter.options = statusFilterOptions

          if (workflowFilters.taskStatus) {
            filter.value = statusFilterOptions.filter(opt => workflowFilters.taskStatus.includes(opt.value))
          }
          break
        case 'assigneesFilter':
          if (workflowFilters.assignees) {
            filter.value = filter.options.filter(opt => workflowFilters.assignees.includes(Number(opt.value)))
          }

          break
        case 'authorsFilter':
          if (workflowFilters.authors) {
            filter.value = filter.options.filter(opt => workflowFilters.authors.includes(Number(opt.value)))
          }

          break
        case 'priorityFilter':
          filter.options = prioritiesFilterOptions

          if (workflowFilters.priorities) {
            filter.value = prioritiesFilterOptions.filter(opt => workflowFilters.priorities.includes(opt.value))
          }
          break
        case 'archivedFilter':
          filter.options = archivedFilterOptions

          if (typeof workflowFilters.isArchived === 'boolean') {
            filter.value = archivedFilterOptions.find(opt => opt.value === workflowFilters.isArchived)
          } else {
            filter.value = null
          }
          break
        case 'formsFilter':
          if (workflowFilters.form) {
            filter.value = filter.options.filter(opt => workflowFilters.form.includes(Number(opt.value)))
          }

          break
      }

      const hasSomeDateFiltered = filter.start && filter.end
      const hasSomeItemSelected = filter.value?.length
      const hasArchivedTrue = filter.value?.value && filter.id === 'archivedFilter'

      if (hasSomeDateFiltered || hasSomeItemSelected || hasArchivedTrue) {
        hasInitialValue = true
      }
    })

    $scope.showFilters = hasInitialValue

    $timeout(() => {
      api._onHeightsChange(100)
    }, 200, false)
  }

  function _setUrl (boardId, filters) {
    const filtersObject = {
      deliveryDateStart: filters.deliveryDateStart,
      deliveryDateEnd: filters.deliveryDateEnd,
      priorities: filters.priorities,
      assignees: filters.assignees,
      authors: filters.authors,
      creationDateStart: filters.creationDateStart,
      creationDateEnd: filters.creationDateEnd,
      isArchived: filters.isArchived,
      taskStatus: filters.taskStatus,
      taskTypes: filters.taskTypes,
      form: filters.form,
      board: boardId
    }

    const url = $location.search()
    const searchOptions = Object.assign({}, url, filtersObject)
    $location.search(searchOptions)
  }

  function _addFiltersInitialValues (url) {
    if (url.board) {
      workflowFilters.boardId = url.board
    }

    if (url.deliveryDateStart) {
      workflowFilters.deliveryDateStart = url.deliveryDateStart
    }

    if (url.deliveryDateEnd) {
      workflowFilters.deliveryDateEnd = url.deliveryDateEnd
    }

    if (url.creationDateStart) {
      workflowFilters.creationDateStart = url.creationDateStart
    }

    if (url.creationDateEnd) {
      workflowFilters.creationDateEnd = url.creationDateEnd
    }

    if (url.isArchived !== undefined) {
      workflowFilters.isArchived = url.isArchived
    } else {
      delete workflowFilters.isArchived
    }

    if (url.taskStatus) {
      workflowFilters.taskStatus = Array.isArray(url.taskStatus) ? url.taskStatus : Array(url.taskStatus)
    }

    if (url.taskTypes) {
      workflowFilters.taskTypes = Array.isArray(url.taskTypes) ? url.taskTypes : Array(url.taskTypes)
    }

    if (url.priorities) {
      workflowFilters.priorities = Array.isArray(url.priorities) ? url.priorities : Array(url.priorities)
    }

    if (Array.isArray(url.form)) {
      workflowFilters.form = url.form.map(Number)
    } else if (!Array.isArray(url.form) && url.form) {
      workflowFilters.form = [Number(url.form)]
    }

    if (Array.isArray(url.authors)) {
      workflowFilters.authors = url.authors.map(Number)
    } else if (!Array.isArray(url.authors) && url.authors) {
      workflowFilters.authors = [Number(url.authors)]
    }

    if (Array.isArray(url.assignees)) {
      workflowFilters.assignees = url.assignees.map(Number)
    } else if (!Array.isArray(url.assignees) && url.assignees) {
      workflowFilters.assignees = [Number(url.assignees)]
    }
  }
}

export { WorkflowFiltersController }
